// 处理 public\assets\js\config.js

const ApiUrl = window.sysConfig.ApiUrl
const ApiToken = window.sysConfig.ApiToken
const WelcomeText = window.sysConfig.WelcomeText
const WelcomeTitle = window.sysConfig.WelcomeTitle
const VoiceConfig = window.sysConfig.VoiceConfig
const PageTitle = window.sysConfig.PageTitle
const LogoName = window.sysConfig.LogoName//ThHeader中的logoName
const inputTips = window.sysConfig.inputTips//输入框中的提示词
const hotList = window.sysConfig.hotList//热词列表

export {
  ApiUrl,
  ApiToken,
  WelcomeText,
  WelcomeTitle,
  VoiceConfig,
  PageTitle,
  LogoName,
  inputTips,
  hotList
}

